<template>
  <div id="order">
    <custom-table :has-channel="true" excel-type="AirportFinanceFlowing" :summaryList="[
      { name: 'orderFee', beforeUnit: '￥' },
      { name: 'serviceFee', beforeUnit: '￥' },
      { name: 'driverAmount', beforeUnit: '￥' },
      { name: 'dispatchAmount', beforeUnit: '￥' },
      { name: 'platformAmount', beforeUnit: '￥' },
      { name: 'technologyAmount', beforeUnit: '￥' },
    ]" has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns" labelWidth="135">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{
          row.created | filterTime
        }}</template>

        <template v-else-if="item.prop === 'startStationName'">
          <div>{{ row.startStationName }}</div>
        </template>
        <template v-else-if="item.prop === 'endStationName'">
          <div>{{ row.endStationName }}</div>
        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
            @dblclick="$utils.dblclickCopy"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>

        <template v-else-if="item.prop == 'channelAlias'">
          {{ row.channelAlias | filterConst("HITCHHIKINGCHANNEL") }}
        </template>
        <template v-else-if="item.prop == 'incomeType'">
          {{ row.incomeType | filterConst("INCOME") }}
        </template>

        <template v-else-if="
          [
            'orderFee',
            'serviceFee',
            'driverAmount',
            'dispatchAmount',
            'platformAmount',
            'technologyAmount',
          ].includes(item.prop)
        ">
          <span class="util-money"> ¥{{ row[item.prop] || 0 }} </span>
        </template>

        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] ? row[item.prop] : "-" }}</span>
        </template>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "order",
  components: {},
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/flowing",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          // {
          //   type: "select",
          //   field: "incomeType",
          //   name: "收入类型",
          //   value: "",
          //   option: [
          //     { value: "完单", label: "完单" },
          //     { value: "销单", label: "销单" },
          //   ],
          // },
          { type: "input", field: "licenseNo", name: "车辆信息", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          {
            type: "datetime",
            field: "time",
            dateProp: { start: "startTime", end: "endTime" },
            name: "完成/取消时间",
            value: [],
          },
        ],
      },
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", minWidth: 200 },
        { prop: "incomeType", label: "收入类型", minWidth: 80 },
        { prop: "licenseNo", label: "车辆号牌", minWidth: 120 },
        { prop: "driverName", label: "司机姓名", minWidth: 80 },
        { prop: "startStationName", label: "出发地", minWidth: 130 },
        { prop: "endStationName", label: "目的地", minWidth: 130 },
        { prop: "passengerNum", label: "乘车人数", minWidth: 80 },
        { prop: "orderFee", label: "订单金额", minWidth: 120 },
        { prop: "serviceFee", label: "信息费", minWidth: 100 },
        { prop: "driverAmount", label: "司机收入", minWidth: 120 },
        { prop: "dispatchAmount", label: "业务收入", minWidth: 120 },
        { prop: "platformAmount", label: "平台收入", minWidth: 120 },
        { prop: "technologyAmount", label: "技术服务", minWidth: 120 },
        { prop: "created", label: "完单/取消时间", minWidth: 140 },
      ],
      // 状态
      status: null,
      show: false,
      showCancel: false,
      rowData: {},
    };
  },
  watch: {},
  methods: {
    actionFn({ type, row }) {
      switch (type) {
        case "look":
          this.rowData = row;
          this.show = true;
          break;
      }
    },
    /**
     * 状态改变
     */

    handClose() {
      this.rowData = {};
      this.show = false;
      this.showCancel = false;
    },
  },
  created() { },
};
</script>

<style scoped lang="less">
#order {}
</style>
